"use client";

import * as React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { SheetContent } from "@/components/ui/sheet";
import { DialogContent } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

/**
 * Renders as a bottom sheet on mobile and a centered dialog on tablet/desktop.
 * The root stays <Sheet> (Radix Dialog.Root) so triggers/titles work in both modes.
 */
export function ResponsiveModalContent({
  className,
  sheetClassName,
  dialogClassName,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof DialogContent> & {
  sheetClassName?: string;
  dialogClassName?: string;
}) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <SheetContent side="bottom" className={cn(className, sheetClassName)} {...props}>
        {children}
      </SheetContent>
    );
  }

  return (
    <DialogContent
      className={cn(
        "max-h-[85vh] w-[calc(100%-2rem)] max-w-lg overflow-y-auto rounded-2xl no-scrollbar",
        dialogClassName,
      )}
      {...props}
    >
      {children}
    </DialogContent>
  );
}
